import React from 'react';
import { IconChat, IconMail } from '../icons';
import { PortalButton, PortalButtonVariant } from '../ui';

export type AgentContactButtonsProps = {
  talkName: string;
  wa: string | null;
  mail: string | null;
  writeLabel: string;
  emailLabel: string;
  waSpec: string;
  mailSpec: string;
  /** Disable both (e.g. decline in flight). `<a>` must still honor disabled. */
  busy?: boolean;
  waVariant?: PortalButtonVariant;
  mailVariant?: PortalButtonVariant;
  size?: 'sm';
  fullWidth?: boolean;
  waStyle?: React.CSSProperties;
  mailStyle?: React.CSSProperties;
};

/**
 * Shared WA + mailto CTAs for AgentCard / cancelled panel / decline modal (OUW-88).
 * Renders nothing for a channel whose href is null.
 */
export function AgentContactButtons({
  talkName,
  wa,
  mail,
  writeLabel,
  emailLabel,
  waSpec,
  mailSpec,
  busy = false,
  waVariant = 'secondary',
  mailVariant,
  size,
  fullWidth,
  waStyle,
  mailStyle,
}: AgentContactButtonsProps) {
  void talkName;
  if (!wa && !mail) return null;
  const mailVar: PortalButtonVariant = mailVariant ?? (wa ? 'ghost' : 'secondary');
  return (
    <>
      {wa ? (
        <PortalButton
          variant={waVariant}
          size={size}
          fullWidth={fullWidth}
          icon={<IconChat size={16} />}
          label={writeLabel}
          data-spec={waSpec}
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          disabled={busy}
          style={waStyle}
        />
      ) : null}
      {mail ? (
        <PortalButton
          variant={mailVar}
          size={size}
          fullWidth={fullWidth}
          icon={<IconMail size={16} />}
          label={emailLabel}
          data-spec={mailSpec}
          href={mail}
          disabled={busy}
          style={mailStyle}
        />
      ) : null}
    </>
  );
}
